import { Package, Palette, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const ProcessSection = () => {
  const navigate = useNavigate();

  const steps = [
    {
      icon: Palette,
      title: "Personnalisez votre oeuvre",
      description: "Importez votre photo et choisissez le style qui vous correspond.",
      color: "text-primary",
    },
    {
      icon: Sparkles,
      title: "Choisissez le support",
      description: "Poster ou poster encadre, selon la finition que vous souhaitez chez vous.",
      color: "text-secondary",
    },
    {
      icon: Package,
      title: "Recevez votre oeuvre",
      description: "Nous l'imprimons avec soin et vous la livrons chez vous.",
      color: "text-accent",
    },
  ];

  return (
    <section id="process" className="section-shell relative py-20">
      <div className="container relative mx-auto px-6">
        <div className="mb-10">
          <div>
            <h2 className="section-title max-w-3xl text-foreground">
              De votre photo a votre tableau, <span className="text-premium">en 3 etapes</span>.
            </h2>
          </div>
        </div>

        <div className="relative grid gap-5 lg:grid-cols-3">
          {steps.map((step, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-[1.8rem] border border-white/65 bg-[linear-gradient(180deg,rgba(255,255,255,0.82),rgba(245,236,229,0.94))] p-6 shadow-card"
            >
              <div className="mb-7 flex items-start justify-between gap-4">
                <div>
                  <div className="text-xs font-semibold uppercase tracking-[0.26em] text-foreground/38">
                    0{index + 1}
                  </div>
                </div>
                <div className="flex h-12 w-12 items-center justify-center rounded-[1rem] bg-white/70 shadow-card">
                  <step.icon className={`h-5 w-5 ${step.color}`} />
                </div>
              </div>

              <h3 className="font-display text-[2rem] leading-none text-foreground md:text-[2.15rem]">
                {step.title}
              </h3>
              <p className="mt-3 max-w-sm text-sm leading-6 text-foreground/66 md:text-[0.95rem]">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <Button
            variant="premium"
            size="lg"
            className="h-14 rounded-full px-8"
            onClick={() => navigate("/create")}
          >
            Démarrer la transformation
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
